<template>
    <q-submenu :base-url="baseUrl" :title="title" :titlelink="titlelink" :buttons="buttons" class="q-sticky"></q-submenu>
</template>
<script>
//table data + search
import QSubmenu from '@/components/navigation/Submenus/QSubmenu.vue'
export default {
    data() {
        return {
            titlelink: null,
            baseUrl: '/news',
        }
    },
    computed: {
        'title': function() {
            var t = [];
            if (this.tenantHasFeature('News', this.current_tenant.ID)) {
                t.push('News')
            }
            if (this.tenantHasFeature('Contests', this.current_tenant.ID)) {
                t.push('Contests')
            }
            if (this.tenantHasFeature('Events', this.current_tenant.ID)) {
                t.push('Events')
            }
            var title_str = t.join(', ');
            return title_str.replace(/,([^,]*)$/, ' & $1')
        },
        'buttons': function() {
            var b = [];
            if (this.tenantHasFeature('News', this.current_tenant.ID)) {
                b.push({
                    label: "News",
                    to: "/news",
                    icon: "fas fa-arrow-alt-circle-right",
                });
            }
            if (this.tenantHasFeature('Contests', this.current_tenant.ID)) {
                b.push({
                    label: "Contests",
                    to: "/contests",
                    icon: "fas fa-arrow-alt-circle-right",
                });
            }
            if (this.tenantHasFeature('Events', this.current_tenant.ID)) {
                b.push({
                    label: "Events",
                    to: "/events",
                    icon: "fas fa-arrow-alt-circle-right",
                });
            }
            return b
        }
    },
    components: {
        QSubmenu
    },
    methods: {},
}
</script>
<style>
</style>